import React from 'react';

function Good(props) {
	return (
		<svg width='63' height='63' viewBox='0 0 63 63' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M31.4999 62.9999C48.8969 62.9999 62.9999 48.8969 62.9999 31.4999C62.9999 14.103 48.8969 0 31.4999 0C14.103 0 0 14.103 0 31.4999C0 48.8969 14.103 62.9999 31.4999 62.9999Z'
				fill='#BAEF90'
			/>
			<path
				d='M23 26C25.2091 26 27 24.2091 27 22C27 19.7909 25.2091 18 23 18C20.7909 18 19 19.7909 19 22C19 24.2091 20.7909 26 23 26Z'
				fill='#559224'
			/>
			<path
				opacity='0.5'
				d='M38.25 58.3497C20.8531 58.3497 6.75019 44.2467 6.75019 26.8499C6.75019 17.5553 10.7765 9.20234 17.1792 3.43652C6.98139 8.65073 0 19.26 0 31.5C0 48.8969 14.1029 62.9998 31.4998 62.9998C39.6023 62.9998 46.9892 59.9397 52.5706 54.9135C48.2741 57.1102 43.407 58.3497 38.25 58.3497Z'
				fill='#7F9E66'
			/>
			<path
				d='M49.7074 25C49.4489 25 49.1042 24.9128 48.9319 24.6513C46.4329 22.3847 42.8137 24.1282 42.7275 24.2154C42.2967 24.3898 41.6935 24.3026 41.3488 23.8667C40.9179 23.518 40.9179 22.9077 41.1764 22.3847C43.0722 19.5078 46.4329 17.7643 49.8798 18.0258C50.5691 18.113 51 18.6361 51 19.3335C50.9138 20.0309 50.3968 20.4668 49.7074 20.4668C48.5872 20.3796 47.467 20.6411 46.4329 21.077C47.8116 21.1642 49.2766 21.6873 50.5691 22.9077C51.0862 23.3436 51.0862 24.1282 50.6553 24.6513C50.3968 24.8256 50.0521 25 49.7074 25Z'
				fill='#559224'
			/>
			<path
				d='M31.5487 50.9841C28.2779 50.1077 25.4434 48.16 23.3883 45.53C22.892 44.8772 22.9941 43.9392 23.6483 43.4462C24.3026 42.9531 25.2444 43.057 25.7407 43.7098C27.4525 45.9507 29.8742 47.4907 32.6068 48.1486C39.1345 49.6749 45.6627 45.6319 47.1619 39.2016C47.3847 38.3702 48.1781 37.9145 48.9622 38.0503C49.7463 38.1861 50.2565 39.0654 50.1219 39.8462C48.2467 47.958 40.0435 52.9632 31.9848 51.0267C31.8271 51.0586 31.6879 51.0214 31.5487 50.9841Z'
				fill='#559224'
			/>
		</svg>
	);
}

export default Good;
